// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FlashSaleTag_wrapper__yIrfG","isLink":"FlashSaleTag_isLink__1OQ2d","title":"FlashSaleTag_title__34jgS","countdownBox":"FlashSaleTag_countdownBox__1Jwh-"};